export {VscodeLabel} from './vscode-label.js';
